module.exports = __webpack_public_path__ + "assets/4932a5a37d0816b81386df078e716007.png";